import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import { Target } from "../../utils"
import Info from "../shared/about/Info"
import HeadingM from "../shared/HeadingM"

const query = graphql`
  query {
    room: file(relativePath: { eq: "one/building.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 500)
      }
    }
  }
`

const AboutInfo = () => {
  const data = useStaticQuery(query)
  const items = {
    name: "one",
    ceo: "中村　佑也",
    openDate: "2020年4月",
    address: "〒378-0056\n群馬県沼田市高橋場4586",
    openingHours: "​9:00 - 18:00",
    phone: "0278-25-4900",
    target: "one" as Target,
    image: getImage(data.room),
    mapLink: "https://maps.app.goo.gl/PLXSg4bd4vqkYfzn6",
  }
  return (
    <div>
      <HeadingM title="施設について" target="one" />
      <Info {...items} />
    </div>
  )
}

export default AboutInfo
